import { UserCard } from "@/queries/models"
import { calculateAgeFromBirthDate } from "@/utils/ageUtils"

import { createPersonDataSchema } from "../schema"

export const isPersonDataComplete = (
  firstName: string,
  lastName: string,
  birthDate: string
): boolean => {
  const result = createPersonDataSchema().safeParse({
    firstName,
    lastName,
    birthDate,
  })
  return result.success
}

export const validateAgeUserOption = (
  option: { birthDate: string },
  minAge: number,
  maxAge: number
): boolean => {
  const age = calculateAgeFromBirthDate(option.birthDate)

  if (age === null) {
    return true
  }

  if (age < minAge || age > maxAge) {
    return false
  }

  return true
}

export const shouldShowAlert = (
  selectedCard: UserCard | null,
  firstName: string,
  lastName: string,
  birthDate: string
): boolean => {
  if (selectedCard === null) {
    return false
  }

  const normalizedBirthDate =
    birthDate.length === 8 ? birthDate.slice(2) : birthDate

  const hasDataChanged =
    firstName !== selectedCard.firstName ||
    lastName !== selectedCard.lastName ||
    normalizedBirthDate !== selectedCard.birthDate

  return hasDataChanged
}

export const formatWtpCardOption = (option: string | UserCard): string => {
  if (typeof option === "string") {
    return option
  }
  return option.wtpNumber
}

export const formatUserOption = (
  option: string | { firstName: string; lastName: string; birthDate: string }
): string => {
  if (typeof option === "string") {
    return option
  }
  return `${option.firstName} ${option.lastName} (${option.birthDate})`
}
